module.exports = __webpack_public_path__ + "static/media/proj5_img1.bcf3c2bb.jpg";